import { defineMessages } from '@/components/formatted_message/FormattedMessage';
import { SupplyPointGeneratorType } from '@enmon/commons/lib/enmon';

export const SUPPLY_POINT_GENERATOR_TYPE_TRANSLATED = defineMessages<SupplyPointGeneratorType>({
  [SupplyPointGeneratorType.BiogasCombustion]: { id: 'app.common.supplyPoint.generatorType.BiogasCombustion' },
  [SupplyPointGeneratorType.CleanBiomassCombustion]: {
    id: 'app.common.supplyPoint.generatorType.CleanBiomassCombustion',
  },
  [SupplyPointGeneratorType.PhotovoltaicPowerPlant]: {
    id: 'app.common.supplyPoint.generatorType.PhotovoltaicPowerPlant',
  },
  [SupplyPointGeneratorType.GeothermalPowerPlant]: {
    id: 'app.common.supplyPoint.generatorType.GeothermalPowerPlant',
  },
  [SupplyPointGeneratorType.LargeHydroPowerPlant]: {
    id: 'app.common.supplyPoint.generatorType.LargeHydroPowerPlant',
  },
  [SupplyPointGeneratorType.SmallHydroPowerPlant]: {
    id: 'app.common.supplyPoint.generatorType.SmallHydroPowerPlant',
  },
  [SupplyPointGeneratorType.WindPowerPlant]: { id: 'app.common.supplyPoint.generatorType.WindPowerPlant' },
  [SupplyPointGeneratorType.DieselGenerator]: { id: 'app.common.supplyPoint.generatorType.DieselGenerator' },
  [SupplyPointGeneratorType.CogenerationUnit]: { id: 'app.common.supplyPoint.generatorType.CogenerationUnit' },
  [SupplyPointGeneratorType.Other]: {
    id: 'app.common.supplyPoint.generatorType.Other',
  },
});
